import { Component, OnInit, ViewChild } from '@angular/core';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { GlobalVariableService } from '../../../services/configuration/global-variable.service';
import { GenericModalService } from '../../../services/generic-modal.service';
import { GlobalVariableModalComponent } from './global-variable-modal/global-variable-modal.component';
import { BusinessProcessService } from '../../../services/business-process.service';

@Component({
  selector: 'app-global-variables',
  templateUrl: './global-variables.component.html',
  styleUrls: ['./global-variables.component.css']
})
export class GlobalVariablesComponent implements OnInit {

  globalVariableList: any[];
  filteredGlobalVariableList = [];
  pleaseWait = false;
  errorMessage: string;
  modalComponent: any = GlobalVariableModalComponent;
  hasRight: boolean;
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    checkboxLabel: 'Mostrar somente criptografados',
    inputTextSearchId: 'txtSearchGlobalVariable',
    inputBoolSearchId: 'showOnlyEncrypted',
    showBooleanFilter: true,
    textFilterPropertyNames: ['globalVariableName', 'shownValue'],
    booleanConditionPropertyName: 'isEncrypted',
    booleanTrueResult: true
  };
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private globalVariableService: GlobalVariableService,
    private modalService: GenericModalService,
    private businessProcessService: BusinessProcessService
  ) { }

  ngOnInit() {
    this.getGlobalVariableList();
    this.checkRights();
  }

  getGlobalVariableList() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.globalVariableService.getAllGlobalVariables()
      .subscribe( list => {
        this.filteredGlobalVariableList = list;
        this.globalVariableList = list;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  onAddNew() {
    if (this.hasRight) {
      const newGlobalVariable = { };
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Criar variável global', newGlobalVariable);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onEditGlobalVariable(globalVariable: any) {
    if (this.hasRight) {
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar variável global', globalVariable);
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onDeleteGlobalVariable(globalVariable: any) {
    if (this.hasRight) {
      this.errorMessage = '';
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão da variável global?');
      alert.then( resp => {
        if (resp.value) {
          this.globalVariableService.removeGlobalVariable(globalVariable.globalVariableName)
            .subscribe( () => {
                this.ngOnInit();
              },
              error1 => {
                this.errorMessage = error1;
              });
        }
      });
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  checkValue(globalVariable) {
    if (globalVariable.isEncrypted) {
      globalVariable.shownValue = 'Valor criptografado';
      return `<span class="text-gray"><i class="fas fa-lock mr-2 text-sm"></i>Valor criptografado</span>`;
    } else {
      globalVariable.shownValue = globalVariable.value;
      const length = 150;
      if (globalVariable.value.length > length) {
        return globalVariable.value.substr(0, length) + '...';
      } else {
        return globalVariable.value;
      }
    }
  }

  checkRights() {
    this.errorMessage = '';
    this.businessProcessService.checkRights(4194304)
      .subscribe( rights => {
        this.hasRight = rights.length > 0;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  onFilterList(filteredData: any[]) {
    this.filteredGlobalVariableList = filteredData;
  }

}
